import { render, staticRenderFns } from "./xilie.vue?vue&type=template&id=53701ae2&scoped=true&"
import script from "./xilie.vue?vue&type=script&lang=js&"
export * from "./xilie.vue?vue&type=script&lang=js&"
import style0 from "./xilie.vue?vue&type=style&index=0&id=53701ae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53701ae2",
  null
  
)

component.options.__file = "xilie.vue"
export default component.exports